export const downloadFile = ({ file, fileName, type }: { file: Blob, fileName: string, type?: string }) => {
  const href = URL.createObjectURL(file);
  const name = type ? `${fileName}.${type}` : fileName;

  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', name);
  link.click();

  URL.revokeObjectURL(href);
};

export const convertToCSV = (byteArrays: Uint8Array[]): string => {
  const mergedArray = byteArrays.reduce((acc, val) => {
    const merged = new Uint8Array(acc.length + val.length);
    merged.set(acc, 0);
    merged.set(val, acc.length);
    return merged;
  }, new Uint8Array());

  const decoder = new TextDecoder('utf-8');
  const csvString = decoder.decode(mergedArray);

  return csvString;
};
